import React from 'react';

import {
  FightIcon, FireIcon, GunIcon, PeopleIcon, BalaklavaIcon, BriefcaseIcon, LyingPersonIcon, HandsUpIcon, FallIcon,
} from '@vlabs/icons';
import i18n from 'i18next';

export const analyticsUiConfigByType = {
  people_count: {
    icon: <PeopleIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.crowd.label');
    },
  },
  fights_analytics: {
    icon: <FightIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.fight.label');
    },
  },
  weapon_analytics: {
    icon: <GunIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.weapon.label');
    },
  },
  fire_analytics: {
    icon: <FireIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.fire.label');
    },
  },
  facecover_analytics: {
    icon: <BalaklavaIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.facecover.label');
    },
  },
  bags_analytics: {
    icon: <BriefcaseIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.bag.label');
    },
  },
  lying_analytics: {
    icon: <LyingPersonIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.lying.label');
    },
  },
  handsup_analytics: {
    icon: <HandsUpIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.handsup.label');
    },
  },
  fall_analytics: {
    icon: <FallIcon />,
    get label() {
      return i18n.t('videoAnalytics:event_type.fall.label');
    },
  },
};
